import { render } from "./AlertBanner.vue?vue&type=template&id=207e58ea&scoped=true&ts=true"
import script from "./AlertBanner.vue?vue&type=script&lang=ts"
export * from "./AlertBanner.vue?vue&type=script&lang=ts"

import "./AlertBanner.vue?vue&type=style&index=0&id=207e58ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207e58ea"]])

export default __exports__